var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-user",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 7,
    r: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.0d3cde29811636d534d72a2ea4f24dad.svg";
export { ForwardRef as ReactComponent };